export default __webpack_public_path__ + "static/media/山海世界_white.4842aaa1.jpg";